import Skin1 from '../res/skin-1.png';
import Skin2 from '../res/skin-2.png';
import Skin3 from '../res/skin-3.png';
import Skin4 from '../res/skin-4.png';
import Skin5 from '../res/skin-5.png';
import Skin6 from '../res/skin-6.png';
import Skin7 from '../res/skin-7.png';
import Skin8 from '../res/skin-8.png';

// User reference order; dimensions and visible bounds retain the generated alpha padding.
export const SKINS = [
  {id: 'skin-1', name: '皮肤 1', score: 50, image: Skin1, width: 1283, height: 1226, bottom: 56, visibleHeight: 1086},
  {id: 'skin-2', name: '皮肤 2', score: 100, image: Skin2, width: 1247, height: 1261, bottom: 51, visibleHeight: 1126},
  {id: 'skin-3', name: '皮肤 3', score: 200, image: Skin3, width: 1254, height: 1254, bottom: 142, visibleHeight: 950},
  {id: 'skin-4', name: '皮肤 4', score: 400, image: Skin4, width: 1083, height: 1452, bottom: 33, visibleHeight: 1402},
  {id: 'skin-5', name: '皮肤 5', score: 525, image: Skin5, width: 1118, height: 1407, bottom: 48, visibleHeight: 1293},
  {id: 'skin-6', name: '皮肤 6', score: 650, image: Skin6, width: 1254, height: 1254, bottom: 130, visibleHeight: 972},
  {id: 'skin-7', name: '皮肤 7', score: 775, image: Skin7, width: 1254, height: 1254, bottom: 81, visibleHeight: 1102},
  {id: 'skin-8', name: '皮肤 8', score: 900, image: Skin8, width: 1145, height: 1374, bottom: 50, visibleHeight: 1261},
];

export function selectedSkin(id, best) {
  return SKINS.find(skin => skin.id === id && best >= skin.score) || null;
}
